import { Link } from "gatsby-plugin-modal-routing-3"
import React from "react"
import Card from "../../../blocks/card/Card"
import * as classNames from "./GrpBlockSearchResult.module.scss"
import Icon from "../../../blocks/icon/Icon"

function GrpBlockSearchResult({ page }) {
  return (
    <>
      <Card
        className={`${classNames.PageCard}`}
        tag="article"
      >
        <div className={classNames.pageContent}>
          <Link to={page?.route}>
            <h3>{page?.title}</h3>
          </Link>
          <div>
            <p>{page?.description}</p>
          </div>

          <Link
            to={page?.route}
            className={classNames.btn}
          >
            <Icon
              icon="arrowRight"
              color="var(--secondary-color)"
            />
            <div>
              <Link to={page?.route}>Voir Plus</Link>
            </div>
          </Link>
        </div>
      </Card>
    </>
  )
}

export default GrpBlockSearchResult
